import { RoleGetResult } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Dialog } from '@optimus-web/core';
import { useDeleteRole, useDeleteRoles } from './queries';

const CancelButton = ({ onClick }: { onClick: () => void }) => (
    <Button onClick={onClick} variant="tertiary" size="medium" type="submit">
        <LocalizedText textKey={TextKey.Cancel} />
    </Button>
);

const DeleteButton = ({ onClick }: { onClick: () => void }) => (
    <Button onClick={onClick} variant="destructive" size="medium" type="submit">
        <LocalizedText textKey={TextKey.Delete} />
    </Button>
);

export const DeleteRoleDialog = ({
    role,
    onSuccess,
    active,
    onClose,
}: {
    role: RoleGetResult;
    onSuccess?: () => void;
    active: boolean;
    onClose: () => void;
}) => {
    const deleteRole = useDeleteRole();

    const deleteSelectedRole = () => {
        deleteRole.mutate(
            { role },
            {
                onSettled: onClose,
                onSuccess,
            }
        );
    };

    return (
        <Dialog
            title={<LocalizedText textKey={TextKey.RoleDeleteSingleTitle} substitutes={{ roleName: role.name }} />}
            footer={{
                secondary: <CancelButton onClick={onClose} />,
                primary: <DeleteButton onClick={deleteSelectedRole} />,
            }}
            active={active}
            loading={deleteRole.isPending}
            onClose={onClose}
        >
            <LocalizedText textKey={TextKey.RoleDeleteSingleDescription} />
        </Dialog>
    );
};

export const DeleteRolesDialog = ({
    roleIds,
    onSuccess,
    active,
    onClose,
}: {
    roleIds: string[];
    onSuccess?: () => void;
    active: boolean;
    onClose: () => void;
}) => {
    const deleteRoles = useDeleteRoles();

    const deleteSelectedRoles = () => {
        deleteRoles.mutate(
            { roleIds },
            {
                onSettled: onClose,
                onSuccess,
            }
        );
    };

    return (
        <Dialog
            title={<LocalizedText textKey={TextKey.RoleDeleteMultiTitle} />}
            footer={{
                secondary: <CancelButton onClick={onClose} />,
                primary: <DeleteButton onClick={deleteSelectedRoles} />,
            }}
            active={active}
            loading={deleteRoles.isPending}
            onClose={onClose}
        >
            <LocalizedText textKey={TextKey.RoleDeleteMultiDescription} />
        </Dialog>
    );
};
